
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/arbitrage",
      function () {
        return require("private-next-pages/section/arbitrage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/arbitrage"])
      });
    }
  